export const path = Object.freeze({
  homepage: "/",
  cart: "/cart",
  loginPage: "/login",
  registerpage: "/register",
  checkout: "/checkout",
  product: "/shop",
  detail: "/details",
  // test: "/load",
});
